import { createAction } from '@reduxjs/toolkit';

export const clearPaymentState = createAction('payments/CLEAR_PAYMENT_STATE');
